<template v-slot:option="items">
  <div>
    <SelectItems
      label="nome"
      v-model="internalFields.value"
      :items="items"
      :loading="loading"
      :placeholder="placeholder"
      :disabled="disabled"
      :reduceFunction="(state) => state[propValueName]"
    >
      <template #option="{ data }">
        <img
          class="size-img mr-2"
          :src="require(`../../assets/img/estados/${data.uf}.png`)"
        />
        <span>{{ data.nome }} / {{ data.uf }}</span>
      </template>
      <template #selected-option="{ data }">
        <div :title="data.nome">
          <img
          class="size-img mr-1"
          :src="require(`../../assets/img/estados/${data.uf}.png`)"
        />
        <span>{{ getLabelName(data.nome) }}</span>
        </div>
      </template>
    </SelectItems>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import SelectItems from './SelectItems.vue';

export default {
  name: 'SelectStates',
  model: {
    prop: 'value',
    event: 'update:value',
  },
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Estado',
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    propValueName: {
      type: String,
      default: 'id',
    },
    excludeSelectedValues: {
      type: Boolean,
      default: false,
    },
    alreadySelectedValues: {
      type: Array,
      default: () => [],
    },
    maxCharactersToShow: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      items: [],
      internalFields: {
        value: '',
      },
    };
  },
  watch: {
    'internalFields.value': function () {
      this.$emit('update:value', this.internalFields.value);
    },
    value() {
      this.internalFields.value = this.value;
    },
    estados: {
      deep: true,
      handler() {
        this.items = this.estados || [];

        this.handleSelectedValues();
      },
    },
    alreadySelectedValues: {
      deep: true,
      handler() {
        this.handleSelectedValues();
      },
    },
  },
  computed: {
    ...mapState(['estados']),
  },
  created() {
    this.internalFields.value = this.value;
    this.items = this.estados || [];

    this.handleSelectedValues();
  },
  mounted() {
    if (!this.estados || !this.estados.length) {
      this.$store.dispatch('loadEstados').then(() => {
        this.items = this.estados || [];

        this.handleSelectedValues();
      });
    }
  },
  methods: {
    getLabelName(name) {
      if (!name) return "";
      
      if (name.length <= this.maxCharactersToShow) return name;

      return `${name.slice(0, this.maxCharactersToShow)}...`;
    },
    handleSelectedValues() {
      if (!this.excludeSelectedValues) return;

      this.items = this.estados.filter((x) => {
        // Se for o estado selecionado atualmente, temos que adicioná-lo também
        // ao array para o input não ficar vazio
        if (x[this.propValueName] === this.value) return true;

        return !this.alreadySelectedValues.includes(x[this.propValueName]);
      });
    },
  },
  components: {
    SelectItems,
  },
};
</script>

<style scoped>
.size-img {
  height: 20px;
  width: auto;
}
</style>